import { ArrowRight, Sparkles } from 'lucide-react'
import { InteractiveDevice } from './InteractiveDevice'
import { StoreBadgeRow } from './StoreBadges'

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -top-40 -z-10 mx-auto h-[640px] max-w-7xl bg-[radial-gradient(60%_60%_at_50%_18%,rgba(0,82,204,0.14),rgba(88,86,214,0.08),transparent_72%)]"
      />
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 pb-16 pt-12 md:grid-cols-12 md:gap-8 md:pt-20 md:pb-24">
        <div className="md:col-span-7">
          <span className="chip animate-fade-up bg-white text-ink-soft shadow-sm">
            <Sparkles size={14} className="text-brand" />
            Now live on Google Play &amp; the App Store
          </span>

          <h1 className="mt-5 text-balance animate-fade-up" style={{ animationDelay: '80ms' }}>
            Every insurance calculator,
            <br className="hidden sm:block" />{' '}
            <span className="bg-gradient-to-r from-[#0052CC] to-[#5856D6] bg-clip-text text-transparent">
              in one beautiful app.
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-lg text-ink-soft animate-fade-up" style={{ animationDelay: '160ms' }}>
            BimaUncle puts Motor, Health, Fire, Engineering, Liability and
            Personal Accident calculators on your phone — plus a policy wallet,
            office &amp; hospital finders, instant quotes and one-tap PDF
            proposals. Built for the way agents actually work.
          </p>

          <div className="mt-7 animate-fade-up" style={{ animationDelay: '240ms' }}>
            <StoreBadgeRow height={54} />
            <a
              href="#features"
              className="btn-secondary group mt-4 inline-flex"
            >
              See what's inside
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-0.5" />
            </a>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-ink-soft animate-fade-up" style={{ animationDelay: '320ms' }}>
            <Stat label="Products" value="50+" />
            <Stat label="Lines of business" value="8" />
            <Stat label="On" value="Android & iOS" />
          </div>
        </div>

        <div className="md:col-span-5">
          <InteractiveDevice />
        </div>
      </div>
    </section>
  )
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <span className="inline-flex items-baseline gap-1.5">
      <span className="text-base font-bold text-ink">{value}</span>
      <span className="text-xs uppercase tracking-wider">{label}</span>
    </span>
  )
}
